// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2nSe-{color:#5d748c;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:14px;line-height:18px;margin-top:4px}._16V1L{padding-left:4px}._2k9OW{list-style:none;padding-left:4px}._3AQW0{-ms-flex-align:center;align-items:center;list-style:none}.VwUyo{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.yRw7C{height:18px;margin-right:3px;width:18px}._2Ktip{color:#12ac51;stroke:#12ac51}._2ZzSE{color:#d82111;stroke:#d82111}._3Mea1{background-color:#5d748c;border-radius:50%;height:5px;margin:0 8px 0 3px;width:5px}", ""]);
// Exports
exports.locals = {
	"criteria": "_2nSe-",
	"criteria__list": "_16V1L",
	"criteria__list--isValidated": "_2k9OW",
	"criteria__listItem": "_3AQW0",
	"criteria__listItem__innerContainer": "VwUyo",
	"criteria__listItem__icon": "yRw7C",
	"criteria__listItem--isValid": "_2Ktip",
	"criteria__listItem--isNotValid": "_2ZzSE",
	"criteria__listItemBullet": "_3Mea1"
};
module.exports = exports;
